import Maybe from "crocks/Maybe"
const { Just, Nothing } = Maybe

export const head = xs => (xs && Array.isArray(xs) && xs.length > 0 ? Just(xs[0]) : Nothing())
export const tail = xs => (xs && Array.isArray(xs) && xs.length > 0 ? Just(xs.slice(1)) : Nothing())
export const init = xs =>
    xs && Array.isArray(xs) && xs.length > 0 ? Just(xs.slice(0, -1)) : Nothing()
export const last = xs =>
    xs && Array.isArray(xs) && xs.length > 0 ? Just(xs[xs.length - 1]) : Nothing()
